module.exports = __webpack_public_path__ + "static/media/m9tj658.47a4bef8.png";